import { declOfNum } from '@/commons/helpers';

export const MESSAGES = {
  REQUIRED: 'Обязательное поле',
  MIN_LENGTH: (num) => `Минимум ${num} ${declOfNum(num, 'символ', 'символа', 'символов')}`,
  MAX_LENGTH: (num) => `Максимум ${num} ${declOfNum(num, 'символ', 'символа', 'символов')}`,
  MIN_MAX_VALUE: (min, max) => `Значение может быть от ${min} до ${max}`,
  INCORRECT_FIRSTNAME: 'Некорректное имя',
  INCORRECT_LASTNAME: 'Некорректная фамилия',
  INCORRECT_EMAIL: 'Некорректный адрес эл. почты',
  INCORRECT_PHONE: 'Некорректный номер телефона',
  EMAIL_MATCH: 'Не существует пользователя с таким адресом эл. почты',
  START_SPACES: 'Нельзя использовать пробел в начале',
  EMAIL_DOES_NOT_EXIST: 'С указанным адресом электронной почты не связан ни один активный пользователь',
  PASSWORD_MISMATCH: 'Пароли не совпадают',
  PASSWORDS_MUST_DIFFERENT: 'Новый пароль должен отличаться от старого',
  PASSWORD_MUST_HAVE_NUMBER: 'Пароль должен содержать минимум одну цифру',
  PASSWORD_MUST_HAVE_LATIN_LOWERCASE: 'Минимум одна латинская буква нижнего регистра',
  PASSWORD_MUST_HAVE_LATIN_UPPERCASE: 'Минимум одна латинская буква верхнего регистра',
  PASSWORD_SPEC_CHARS: 'Пароль должен содержать спецсимволы',
  PASSWORD_OTHER_CHARS: 'Пароль может содержать только латинские буквы, цифры и спецсимволы',
};

export const NO_ACCESS_MESSAGE = 'У вас недостаточно прав доступа';
